import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import Text from '../Text';
import { useState } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { api } from '../../maps/data.js';
import Divider from '@mui/material/Divider';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { colors } from '../../maps/colors';

export default function InstallerAddUsersDialog(props) {
    const { open, onClose, installer } = props;
    const newUser = !Object.keys(open).length;

    let [email, s_email] = useState('');
    const [name, s_name] = useState('');
    const [password, s_password] = useState('');
    const [confirm_password, s_confirm_password] = useState('');
    const [role, s_role] = useState('INSTALLER_ADMIN');

    const save = async () => {
        await api({
            type: 'addUser',
            data: {
                email, name, password, confirm_password, role,
                installerId: installer._id
            }
        });
        onClose();
    }

    const allowAddUsersType = ['INSTALLER_ADMIN'];

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <ValidatorForm
                onSubmit={save}
                onError={errors => console.log(errors)}>

                <DialogTitle id="alert-dialog-title">
                    {newUser ? <Tx>user.addUser.title</Tx> : <Tx>user.editUser.title</Tx>} <div style={{ color: colors.GRAY1, fontSize: 12 }}>[{installer.name}]</div>
                </DialogTitle>
                <DialogContent style={{ paddingTop: 5 }}>

                    <Text
                        label="user.email"
                        value={email}
                        onChange={s_email}
                        validators={['required', 'isEmail']}
                        errorMessages={['this field is required', 'email is not valid']} />
                    <Text
                        label="user.name"
                        value={name}
                        onChange={s_name}
                        validators={['required']}
                        errorMessages={['this field is required']} />

                    <Divider style={{ marginBottom: 10 }} />

                    <Text
                        label="user.password"
                        value={password}
                        onChange={s_password}
                        type="password"
                        validators={['required']}
                        errorMessages={['this field is required']} />
                    <Text
                        label="user.confirm_password"
                        value={confirm_password}
                        onChange={s_confirm_password}
                        type="password"
                        validators={['required']}
                        errorMessages={['this field is required']} />

                    <Divider style={{ marginBottom: 10 }} />

                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label"><Tx>user.selectRole</Tx></FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            name="radio-buttons-group"
                            value={role}
                            onChange={e => s_role(e.target.value)}
                        >
                            {
                                allowAddUsersType.map((role, idx) => <FormControlLabel key={idx} value={role} control={<Radio />} label={<Tx>{`user.add.${role}`}</Tx>} />)
                            }
                        </RadioGroup>
                    </FormControl>



                </DialogContent>

                <DialogActions>

                    <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                    <Button autoFocus type='submit'>
                        <Tx>g.save</Tx>
                    </Button>

                </DialogActions>
            </ValidatorForm>
        </Dialog>)
}